import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AnimatedButtonModule } from '@shared/components/animated-button/animated-button.module';
import { ModalFormHostStateService } from '@shared/components/modal-form-host/modal-form-host-state.service';
import { ModalConfirmationFormHostComponent } from './modal-confirmation-form-host.component';
import { ModalFormHostComponent } from './modal-form-host.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        AnimatedButtonModule
    ],
    exports: [ModalFormHostComponent, ModalConfirmationFormHostComponent],
    providers: [ModalFormHostStateService],
    declarations: [ModalFormHostComponent, ModalConfirmationFormHostComponent]
})
export class ModalFormHostModule { }
